<template>
  <v-footer :fixed="fixed" app class="pa-3">
    <span>Gurbani Darpan &copy; 2019</span>
  </v-footer>
</template>

<script>
export default {
  data () {
    return {
      fixed: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PageFooter.vue